const React = require('react')
const { TrackJS } = require('trackjs')
const { ThemeProvider } = require('styled-components')

const { ErrorBoundary } = require('components/common/error-boundary')
const { env } = require('src/config')
const { theme } = require('src/styles/theme')

// global styles
require('reset-css')
require('./src/styles/css/global.scss')

function setupTrackJS() {
  if (env.TRACKJS_TOKEN) {
    TrackJS.install({
      token: env.TRACKJS_TOKEN,
      application: 'developers-portal-gatsby',
      network: { error: false },
      window: { promise: false },
    })
  }
}

exports.onClientEntry = () => {
  setupTrackJS()
}

exports.wrapRootElement = ({ element }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>{element}</ThemeProvider>
    </ErrorBoundary>
  )
}
